import React from 'react';
import PropTypes from 'prop-types';
import { isEmptyObject } from '../../../utils/common/index';
import ScrollableTabs from '../../../components/TabPanel/index'

import {
  triggerFetchLastSevenDayTransaction,
  triggerFetchLastSevenDayCSV,
  triggerFetchRechargeWalletBalance,
  triggerFetchRechargeWalletBalanceCSV,
  triggerFetchTopRetailers,
  triggerFetchBottomRetailers
} from '../../../redux/actions';


export default function OthersConnectivity(props) {

  const { activationModel: { secTilesMasterTxDtos: tilesDto = {}, isSectionActive = '' , sectionName}, ...other } = props;

  if (isSectionActive === "Y") {
    if (!isEmptyObject(tilesDto)) {
      return (
        <>
          <ScrollableTabs 
            sectionHeader={'Recharge ' + sectionName} 
            section={sectionName}
            tabsDto={tilesDto} 
            sortingProperty='tileId' 
            sortingOrder='asc'
            tabVariant='fullWidth'
            color= '#7caeea'
            triggerFetchLastSevenDayTransaction={triggerFetchLastSevenDayTransaction}
            triggerFetchLastSevenDayCSV={triggerFetchLastSevenDayCSV}
            triggerFetchRechargeWalletBalance={triggerFetchRechargeWalletBalance}
            triggerFetchRechargeWalletBalanceCSV={triggerFetchRechargeWalletBalanceCSV}
            triggerFetchTopRetailers={triggerFetchTopRetailers}
            triggerFetchBottomRetailers={triggerFetchBottomRetailers}
            {...other}
          />
        </>
      );
    }
    else {
      return null
    }
  }
  else {
    return null
  }
}

OthersConnectivity.propTypes = {
  tilesDto: PropTypes.arrayOf(
    PropTypes.shape({
      tileId: PropTypes.number,
      tileName: PropTypes.string,
      isTileActive: PropTypes.string,
      tileEndPointUrl: PropTypes.string,
      moduleSecMasterTransactionDto: PropTypes.any
    })
  )
}